import { LoadingButton } from "@mui/lab";
import {
  Alert,
  Box,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import AutoCompleteListFormik from "components/AutoCompleteListFormik";
import CustomDialog from "components/CustomDialog";
import { useFormik } from "formik";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAdminThunk } from "store/reducers/accounts";
import { clearMainStockState, mainStockTransactionThunk } from "store/reducers/inventory/stock/mainStockSlice";
import * as yup from "yup";

const TransferMainStock = ({ open, handleClose, stock }) => {
  const dispatch = useDispatch();
  const validation = yup.object({
    qty: yup.number().required().positive().min(1).max(stock.qty),
  });
  const formik = useFormik({
    initialValues: {
      admin: null,
      qty: stock.qty,
      product_variant: stock.product_variant,
      in_or_out: "out",
    },
    validationSchema: validation,
    onSubmit: (data) => {
      //   console.log(data);
      dispatch(
        mainStockTransactionThunk({
          stock,
          data: { ...data, admin: data.admin.profile.id },
        })
      );
    },
    enableReinitialize: true,
  });
  const state = useSelector(
    (state) => state.mainStock.mainStockTransactionStatus
  );
  useEffect(() => {
    dispatch(getAdminThunk());
  }, []);
  const admins = useSelector(
    (state) => state.accounts.admins
  ).filter((item) => item.profile);

  useEffect(()=>{
    dispatch(clearMainStockState())
  },[])
  return (
    <CustomDialog
      forceFullScreen={false}
      open={open}
      handleClose={handleClose}
      heading="Transfer stock"
    >
      <Box padding={2}>
        <Typography variant="h6" color="text.secondary">
          You are about to return the following product
        </Typography>
        <Typography variant="h5" color="text.secondary">
          {stock.name}
        </Typography>
        <form onSubmit={formik.handleSubmit} style={{ marginTop: 2 }}>
          <Stack direction="column" spacing={2}>
            <TextField
              fullWidth
              name="qty"
              value={formik.values.qty}
              onChange={formik.handleChange}
              error={Boolean(formik.errors.qty)}
              helperText={formik.errors.qty}
              type="number"
            />
            <AutoCompleteListFormik
              items={admins}
              name="username"
              label="Choose admin"
              formik={formik}
              formikName="admin"
              required={true}
            />
          </Stack>
          {state?.error === "get" && (
            <Alert sx={{ my: 1 }} severity="error">
              Error occurred , {this.state?.errorMessage}
            </Alert>
          )}

          {state?.success === "get" && (
            <Alert sx={{ my: 1 }} severity="success">
              Success
            </Alert>
          )}
          <LoadingButton
            sx={{ mt: 2 }}
            variant="outlined"
            type="submit"
            loading={state?.loading === "get"}
          >
            Submit
          </LoadingButton>
        </form>
      </Box>
    </CustomDialog>
  );
};

export default TransferMainStock;
